import * as React from 'react'
import { useAuth } from '../context'

interface Props {}

const AuthorizeIDN: React.FC<Props> = (props: Props) => {
  const { redirect, setHandleAuthentication } = useAuth()
  setHandleAuthentication(true)
  React.useEffect(() => {
    redirect()
  })
  return <div />
}

export default AuthorizeIDN
